import React from 'react';

export const ContentCardWrapper = ({
    contentType,
    contentLink,
    children,
    render = () => null,
    handleOnClickMetricEmit = () => null,
}) => {
    const redirectContent =
        contentType === 'community-podcast' ||
        contentType === 'editorial-content';
    if (redirectContent) {
        return (
            <a
                className="feed-content-link"
                href={contentLink}
                onClick={handleOnClickMetricEmit}
            >
                {render() || children}
            </a>
        );
    }

    return <>{render() || children}</>;
};
